import { Theme } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useRef } from "react"
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PublicNavbar from "../../components/common/Navbar/PublicNavbar"
import Footer from "../../components/Layouts/Footer"
import ContactUsSection from "../../components/Layouts/Home/ContactUsSection"
import HeroSection from "../../components/Layouts/Home/HeroSection"
import InitialTransition from "../../components/Layouts/Home/InitialTransition"
import JellyBlob from "../../components/Layouts/Home/JellyBlob"
import MobileAppSection from "../../components/Layouts/Home/MobileAppSection"
import OurProcessSection from "../../components/Layouts/Home/OurProcessSection"
import OurServicesSection from "../../components/Layouts/Home/OurServicesSection"
import TrustedBySection from "../../components/Layouts/Home/TrustedBySection"
import routes from '../../constants/routes'
import { RootState } from '../../types'


const useStyles = makeStyles((theme: Theme) => ({
    root: {

    },
}))

const HomePage = () => {
    const token = useSelector((state: RootState) => state.auth.token)
    const history = useHistory()
    const { root } = useStyles()
    const heroSectionRef = useRef<HTMLElement>(null)
    const aboutSectionRef = useRef<HTMLElement>(null)
    const contactUsSectionRef = useRef<HTMLElement>(null)
    const servicesSectionRef = useRef<HTMLElement>(null)

    useEffect(() => {
        if (token) {
            // redirect as per permissions
            history.push(routes.privatePages.DashboardPage.url())
        }
    }, [token])


    return !token ? (
        <AnimatePresence exitBeforeEnter>
            <motion.section exit={{ opacity: 0 }}>
                <InitialTransition />
                {
                    window.innerWidth >= 600 &&
                    <JellyBlob />
                }
                <PublicNavbar
                    isHomePage
                    heroSectionRef={heroSectionRef}
                    aboutSectionRef={aboutSectionRef}
                    servicesSectionRef={servicesSectionRef}
                    contactUsSectionRef={contactUsSectionRef}
                />
                <main className={root}>
                    <HeroSection innerRef={heroSectionRef} />
                    <TrustedBySection />
                    <MobileAppSection />
                    <OurServicesSection innerRef={servicesSectionRef} />
                    <OurProcessSection innerRef={aboutSectionRef} /> 
                    {/* <RoadmapSection /> */}
                    <ContactUsSection innerRef={contactUsSectionRef} />
                </main>
                <Footer />
            </motion.section>
        </AnimatePresence>
    ) : null
}

export default HomePage
